import { Button, Link, Notice, Table, Text, TextField } from "@smooth/design-system-components"
import NextLink from "next/link"
import { useRouter } from "next/router"
import { useState } from "react"
import { useStandingOrderInvoices } from "../hooks/useStandingOrderInvoices"
import Pagination from "src/components/tailwind-components/Pagination"
import { formatDateTime } from "src/features/admin/screen-shared"

const COLUMNS = [
  { key: "id", header: "Id" },
  { key: "user", header: "User" },
  { key: "paymentPromise", header: "Payment Promise" },
  { key: "scheduledOn", header: "Scheduled On" },
  { key: "orderId", header: "Order" },
  { key: "shopId", header: "Shop" },
]

/** オーダー ID は完全一致で絞り込む */
export const StandingOrderInvoiceList = ({ page, orderId }: { page: number; orderId: string }) => {
  const router = useRouter()
  const [searchText, setSearchText] = useState(orderId)
  const { standingOrderInvoices, pagination, error, isLoading } = useStandingOrderInvoices(
    page,
    orderId
  )

  const search = () =>
    router.push({ query: searchText.trim() ? { orderId: searchText.trim() } : {} })

  const rows = standingOrderInvoices.map((invoice) => ({
    id:
      invoice.id === null ? null : (
        <Link href={`/admin/standing-order-invoices/${invoice.id}`}>{invoice.id}</Link>
      ),
    user:
      invoice.userId === null ? null : (
        <Link href={`/admin/users/${invoice.userId}`}>{invoice.userId}</Link>
      ),
    paymentPromise:
      invoice.paymentPromiseId === null ? null : (
        <Link href={`/admin/payment-promises/${invoice.paymentPromiseId}`}>
          {invoice.paymentPromiseId}
        </Link>
      ),
    scheduledOn: formatDateTime(invoice.scheduledOn),
    orderId: invoice.orderId,
    shopId: invoice.shopId,
  }))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center gap-2">
        <Button asChild>
          <NextLink href="/admin/standing-order-invoices/new">新規作成</NextLink>
        </Button>
        <form
          className="flex items-center gap-2"
          onSubmit={(event) => {
            event.preventDefault()
            search()
          }}
        >
          <TextField
            aria-label="Order"
            placeholder="Order（完全一致）"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Button type="submit" variant="outline">
            検索
          </Button>
        </form>
      </div>
      {error && <Notice tone="error">一覧を取得できませんでした</Notice>}
      {isLoading && <Text>読み込み中...</Text>}
      {!error && !isLoading && (
        <>
          <Table
            columns={COLUMNS}
            rows={rows}
            onRowClick={(index) =>
              router.push(`/admin/standing-order-invoices/${standingOrderInvoices[index].id}`)
            }
          />
          <Pagination
            pagination={{
              currentPage: page,
              totalPages: pagination?.totalPages ?? 1,
              totalCount: pagination?.totalCount ?? 0,
            }}
            onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
          />
        </>
      )}
    </div>
  )
}
